export enum CurrencyCodeIconEnum {
    EUR = "€",
    UK = "£",
    USA = "$"
}